import NonConformityTypes from "ContainersForm/NonConformity/types"

const initialState = {
  fullAnomalies: [],
  fullIncidents: [],
  fullAuditRecommendations: [],
}

function nonConformityReducer(state = initialState, { type, payload }) {
  switch (type) {
    case NonConformityTypes?.GET_FULL_ANOMALIES_SUCCESS:
      return {
        ...state,
        fullAnomalies: payload,
      }
    case NonConformityTypes?.GET_FULL_INCIDENTS_SUCCESS:
      return {
        ...state,
        fullIncidents: payload,
      }
    case NonConformityTypes?.GET_FULL_AUDIT_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        fullAuditRecommendations: payload,
      }
    default:
      return state
  }
}

export default nonConformityReducer
